module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Plus","flags":["TRACK"],"track":"More"}}